import React, { useState, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useApi } from '../context/ApiContext';
import AuthContext from '../context/AuthContext'

const Navbar = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.pathname);
  const API_BASE_URL = useApi();
  let fetchUrl = '/opportunity-listings/all/';

  let { user, logOutUser } = useContext(AuthContext)
  console.log(user)

  return (
    <>    
      <header>
        {/* <!-- Header Start --> */}
       <div className="header-area header-transparrent">
           <div className="headder-top header-sticky">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-3 col-md-2">
                            {/* <!-- Logo --> */}
                            <div className="logo">
                                <a href="/"><img style={{width:250}} src={require("../assets/img/logo/logo.png")} alt="" /></a>
                            </div>  
                        </div>
                        <div className="col-lg-9 col-md-9">
                            <div className="menu-wrapper">
                                {/* <!-- Main-menu --> */}
                                <div className="main-menu">
                                    <nav className="d-none d-lg-block">
                                        <ul id="navigation">
                                            <li><a href="/">Home</a></li>
                                            <li><a href={fetchUrl}>Find a Job </a></li>
                                            <li><a href="/post-opportunity">Post Opportunity</a></li>
                                            {/* <li><a href="about.html">About</a></li> */}
                                            <li><a href="#">Page</a>
                                                <ul className="submenu">
                                                    <li><a href="blog.html">Blog</a></li>
                                                    <li><a href="single-blog.html">Blog Details</a></li>
                                                    <li><a href="elements.html">Elements</a></li>
                                                    <li><a href="job_details.html">job Details</a></li>
                                                </ul>
                                            </li>
                                            <li><a href="contact.html">Contact</a></li>
                                        </ul>
                                    </nav>
                                </div>          
                                {/* <!-- Header-btn --> */}
                                
                                {/* <div className="header-btn d-none f-right d-lg-block">
                                    <a href="/register" className="btn head-btn1">Register</a>
                                    <a href="/login" className="btn head-btn2">Login</a>
                                </div> */}
                                {/* <div className="header-btn d-none f-right d-lg-block">
                                {user ? (
                                  <span className="btn head-btn1">Hi, {user.first_name}</span>
                                ) : (
                                  <>
                                    <a href="/register" className="btn head-btn1">Register</a>
                                    <a href="/login" className="btn head-btn2">Login</a>
                                  </>
                                )}
                              </div> */}

                              <div className="header-btn d-none f-right d-lg-block">
      {user ? (
        <>
        
          <span onClick={() => window.location.href = '/user-account'} className="btn head-btn1">Hello, {user.username}</span>
          {/* <button onClick={logOutUser} className="btn head-btn2">
            Logout
          </button> */}
        </>
      ) : (
        <>
          <a href="/register" className="btn head-btn1">Register</a>
          <a href="/login" className="btn head-btn2">Login</a>
        </>
      )}
    </div>

                                
                            </div>
                        </div>
                        {/* <!-- Mobile Menu --> */}
                        <div className="col-12">
                            <div className="mobile_menu d-block d-lg-none"></div>
                        </div>
                    </div>
                </div>
           </div>
       </div>
        {/* <!-- Header End --> */}
    </header>
      
      {/* Bottom Navigation Bar - Only shows on small screens */}
      <div className="d-block d-lg-none" style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        zIndex: 1000,
        padding: '8px 0'
      }}>
        <div className="row justify-content-around" style={{ margin: 0 }}>
          {/* Home */}
          <Link 
            to="/" 
            className="text-center"
            style={{
              textDecoration: 'none',
              color: activeTab === '/' ? '#3498db' : '#7f8c8d'
            }}
            onClick={() => setActiveTab('/')}
          >
            <div>
              <i className="fas fa-home" style={{ fontSize: '1.2rem' }}></i>
              <div style={{ fontSize: '0.7rem', marginTop: '2px' }}>Home</div>
            </div>
          </Link>
          
          {/* Find Opportunity */}
          <Link 
            to={fetchUrl}
            className="text-center"
            style={{
              textDecoration: 'none',
              color: activeTab === '/job_listing' ? '#3498db' : '#7f8c8d'
            }}
            onClick={() => setActiveTab({fetchUrl})}
          >
            <div>
              <i className="fas fa-search" style={{ fontSize: '1.2rem' }}></i>
              <div style={{ fontSize: '0.7rem', marginTop: '2px' }}>Find</div>
            </div>
          </Link>
          
          {/* Post Opportunity */}
          <Link 
            to="/post-opportunity" 
            className="text-center"
            style={{
              textDecoration: 'none',
              color: activeTab === '/post-opportunity' ? '#3498db' : '#7f8c8d'
            }}
            onClick={() => setActiveTab('/post-opportunity')}
          >
            <div>
              <i className="fas fa-plus-circle" style={{ fontSize: '1.2rem' }}></i>
              <div style={{ fontSize: '0.7rem', marginTop: '2px' }}>Post</div>
            </div>
          </Link>
          
          {/* Register/Login - Conditional based on auth status */}
          <Link 
            to="/login" 
            className="text-center"
            style={{
              textDecoration: 'none',
              color: (activeTab === '/login' || activeTab === '/register') ? '#3498db' : '#7f8c8d'
            }}
            onClick={() => setActiveTab('/login')}
          >
            <div>
              <i className="fas fa-user" style={{ fontSize: '1.2rem' }}></i>
              <div style={{ fontSize: '0.7rem', marginTop: '2px' }}>Account</div>
            </div>
          </Link>
          
          {/* Contact */}
          <Link 
            to="/contact" 
            className="text-center"
            style={{
              textDecoration: 'none',
              color: activeTab === '/contact' ? '#3498db' : '#7f8c8d'
            }}
            onClick={() => setActiveTab('/contact')}
          >
            <div>
              <i className="fas fa-envelope" style={{ fontSize: '1.2rem' }}></i>
              <div style={{ fontSize: '0.7rem', marginTop: '2px' }}>Contact</div>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}

export default Navbar;